import React from 'react'

function Footer() {
    return (
        <div className='text-center text-black pt-10 pb-5 dark:bg-slate-900 dark:text-white'>
            Made using <a className='text-blue-600 underline' href="https://docs.wazirx.com">WazirX API</a>
        </div>
    )
}

export default Footer
